import React, { useState } from "react";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import GCSummaryModal from "../../../Component/Common/ReuseableComponent/GCSummaryModal";
import GCPalletIDModal from "./GCPalletIDModal";
import DetailCardComp, { DetailInputDisplay } from "../../../Component/Common/ReuseableComponent/DetailCardComp";

const EasyPutawayCardDesign = ({ items }) => {
  const [sPalletId, setPalletId] = useState("");
  const [sModalOpen, setModalOpen] = useState(false);

   const vMediaQuery = useMediaQuery("(max-width:650px)");

  const onClick = (item) => {
    setPalletId(item?.CI);
    setModalOpen(true);
  };
  return (
    // <Grid container spacing={3} className="easy-putaway-container">
    //   {items.map((item, index) => (
    //     <Grid item xs={12} sm={6} key={index}>
    //       <div className="easy-putaway-card">
    //         <Grid container spacing={1}>
    //           <Grid item xs={6}>
    //             <Typography variant="subtitle1" className="label">Item Code:</Typography>
    //           </Grid>
    //           <Grid item xs={6}>
    //             <Typography variant="body1" className="value">{item.itemCode}</Typography>
    //           </Grid>
    //           <Grid item xs={6}>
    //             <Typography variant="subtitle1" className="label">Item Name:</Typography>
    //           </Grid>
    //           <Grid item xs={6}>
    //             <Typography variant="body1" className="value">{item.itemName}</Typography>
    //           </Grid>
    //           <Grid item xs={6}>
    //             <Typography variant="subtitle1" className="label">PO Qty:</Typography>
    //           </Grid>
    //           <Grid item xs={6}>
    //             <Typography variant="body1" className="value">{item.POQty}</Typography>
    //           </Grid>
    //           {/* Add more fields as needed */}
    //         </Grid>
    //       </div>
    //     </Grid>
    //   ))}
    // </Grid>
    <>
      <Box
                    sx={{
                      mt:5,
                      height: vMediaQuery ? "65vh" : "72vh",
                      overflowY: "auto",
                      py: vMediaQuery ? "0px" : "8px",
                      px: vMediaQuery ? "0px" : "20px",
                    }}
                  >
                    <Grid container spacing={2}>
                      {Array.isArray(items) &&
                        items?.length > 0 &&
                        items?.map((item, index) => (
                          <Grid item xs={12} sm={6} md={4} key={index}>
                            <DetailCardComp
                              data={item}
                              onClick={(item) => {
                                onClick(item);
                              }}
                              headerLabel={item?.Name1}
                              content={
                                <Grid container spacing={1}>
                                  <DetailInputDisplay
                                    label=" Ref No"
                                    value={item?.SuppRefNo1}
                                  />
                                  <DetailInputDisplay
                                    label="ItmCd"
                                    value={item?.SuppRefNo1}
                                  />
                                  <DetailInputDisplay
                                    label="GRNQty"
                                    value={` ${item?.GRNQty}`}
                                  />
                                  <DetailInputDisplay
                                    label="PUTAWAY Qty"
                                    value={item?.PUTAWAYQty}
                                  />
        
                                  <DetailInputDisplay
                                    label="Pending Qty"
                                    value={item?.PendingQty}
                                  />
                                </Grid>
                              }
                            />
                          </Grid>
                        ))}
                    </Grid>
                  </Box>

      <GCPalletIDModal
        xOpen={sModalOpen}
        fCloseModal={() => {
          setModalOpen(false);
        }}
        xTitle="Pallet Id"
        component={
          <>
            <div> 
            <Typography variant="body1" className="value">
                    {sPalletId}
                  </Typography>
            </div>
          </>
        }
      />
    </>
  );
};

export default EasyPutawayCardDesign;
